module.exports = __webpack_public_path__ + "static/media/menuTTS.bc74c42d.svg";